import { render } from "./EstruturaReceitas.vue?vue&type=template&id=e872a558"
import script from "./EstruturaReceitas.vue?vue&type=script&lang=js"
export * from "./EstruturaReceitas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__